import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, setPlayerToken, formatApiError } from "@/lib/api";
import { BrainTapLogo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

// Google OAuth return landing: /auth#session_id=...&code=<room code>
export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = hash.get("session_id") || "";
    const roomCode = (params.get("code") || "").replace(/\D/g, "").slice(0, 6);
    if (!sessionId) {
      setError("No Google session came back — please try again.");
      return;
    }
    let alive = true;
    api.post("/auth/google", { session_id: sessionId }).then(({ data }) => {
      if (!alive) return;
      setPlayerToken(data.token);
      navigate(roomCode ? `/play/${roomCode}` : "/join", { replace: true });
    }).catch((e) => {
      if (alive) setError(formatApiError(e));
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-navy-900 px-4 py-10 text-cream"
      style={{ background: "radial-gradient(circle at 50% 0%, rgba(120,80,255,0.15), transparent 55%), #190a20" }}
      data-testid="auth-callback-page"
    >
      <Link to="/" className="mb-10"><BrainTapLogo lockupClass="h-24" /></Link>
      {error ? (
        <div className="glass w-full max-w-md rounded-3xl p-8 text-center" data-testid="auth-callback-error">
          <h1 className="mb-3 font-display text-2xl font-extrabold uppercase text-coral">Google sign-in failed</h1>
          <p className="mb-6 text-mut">{error}</p>
          <Link to="/join" className="inline-block rounded-full bg-amber px-8 py-3.5 font-display font-extrabold uppercase text-navy-900">Back to join</Link>
        </div>
      ) : (
        <div className="flex items-center gap-3 font-mono text-sm uppercase tracking-[0.3em] text-mut" data-testid="auth-callback-loading">
          <Loader2 size={18} className="animate-spin text-amber" /> Signing you in…
        </div>
      )}
    </div>
  );
}
